import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const StyledLinkItem = styled.div`
  color: ${Variables.colors.complementary_900};
  text-decoration: none;
  &:hover,
  &:active,
  &:visited {
    color: ${Variables.colors.complementary_900};
  }
  li {
    width: 32px;
    height: 32px;
    margin: 0 auto 2px auto;
    padding: 0 7px 0 0;
    border-radius: 50%;
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    list-style: none;
    text-align: right;
    direction: rtl;
    font-size: ${Variables.font_sizes.x_small};
    .list-item-text {
      display: flex;
      align-items: center;
    }
    & > i {
      &:before {
        color: ${Variables.colors.complementary_600};
        margin-left: 9px;
        font-size: 18px;
      }
    }

    &:hover {
      border-radius: 50%;
      padding: 0 7px 0 0;
      background-color: ${Variables.colors.complementary_200};
      ${props => {
        if (props.expand) {
          return `
                border-radius: 4px;
                padding: 8px 26px 8px 0;	
            `;
        } else {
          return `
                border-radius: 50%;
                padding: 0 7px 0 0;
            `;
        }
      }}
    }
    .svg-icon-wrapper {
      margin-left: 8px;
      path {
        fill: ${Variables.colors.complementary_600};
        stroke: ${Variables.colors.complementary_700};
      }
    }

    ${props => {
      if (props.expand) {
        return `
            width: auto;
            height: 32px;
            margin: auto;
            padding: 8px 26px 8px 0;
            border-radius: unset;
        `;
      } else {
        return `
            width: 32px;
            height: 32px;
            margin: 0 auto 2px auto;
            padding: 0 7px 0 0;
            border-radius: 50%;
        `;
      }
    }}
  }
  &.list-item-active {
    border-radius: 50%;
    padding: 0;
    path {
      fill: ${props => props.color};
    }
    li {
      background-color: ${props => props.backgroundcolor};
      color: ${props => props.color};
      ${props => {
        if (props.expand) {
          return `
                border-radius: 4px 0 0 4px;
                padding: 8px 26px 8px 0;		
            `;
        } else {
          return `
                border-radius: 50%;
                padding: 0 7px 0 0;
            `;
        }
      }}
      i {
        &:before {
          color: ${props => props.color};
        }
      }
      &:hover,
      &:active,
      &:visited {
        color: ${props => props.color};
      }
    }
  }
`;
